// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LayoutRightBottom} from 'components/Layout';
import {LocalizedParagraph, type LocalizedText} from 'components/Localized'

type PropsButton = {
  onNext?: () => void,
  title?: LocalizedText,
  widthM?: number,
  widthD?: number,
  marginBottomM?: number,
  marginBottomD?: number,
  marginRightM?: number,
  marginRightD?: number,
  dataBackground?: string,
  dataOutline?: string,
  skipPadding?: boolean
};

type Props = PropsButton & {
  buttons?: Array<PropsButton>,
  children?: React.Node,
}

export default function ButtonNextPage(props: Props): React.Element<any> {
  const {buttons, marginBottomM, marginBottomD, marginRightM, marginRightD, children, ...other} = props;
  return (
    <ButtonWrapper marginBottomM={marginBottomM} marginBottomD={marginBottomD} marginRightM={marginRightM} marginRightD={marginRightD}>
      {props.buttons && props.buttons?.map((value, index) => <ButtonNextItem {...value} key={index} />)}
      {props.title && <ButtonNextItem {...other} />}
      {children}
    </ButtonWrapper>
  );
}

export function ButtonNextItem(props: Props): React.Element<any> {
  const {onNext, title, widthM, widthD, ...other} = props;
  return (
    <NextButton {...other} datawidthm={widthM} datawidthd={widthD} onClick={onNext}>
      {title && <LocalizedParagraph {...title} />}
    </NextButton>
  );
}

export function ButtonNextPageBlack(props: Props): React.Element<any> {
  return (
    <ButtonNextPage {...props} dataBackground="#05141f" />
  );
}

export function ButtonNextPageOutline(props: Props): React.Element<any> {
  return (
    <ButtonNextPage {...props} dataBackground="#05141f" dataOutline="#ffffff" />
  );
}

const ButtonWrapper = styled(LayoutRightBottom)`
  margin-right: ${props => props.theme.layout.mobile ? props.marginRightM ?? 30 : props.marginRightD ?? 80}px;
  margin-bottom: ${props => props.theme.layout.mobile ? props.marginBottomM ?? 30 : props.marginBottomD ?? 51}px;
`;

const NextButton = styled.button`
  min-width: ${props => (props.theme.layout.mobile ? props.datawidthm ?? 100 : props.datawidthd ?? 160)}px;
  height: ${props => props.theme.layout.mobile ? 36 : 55}px;
  padding: 0px ${props => props.theme.layout.mobile ? (props.skipPadding? 0: 14) : (props.skipPadding? 0: 24)}px;
  margin-left: ${props => props.theme.layout.mobile ? 10 : 10}px;
  background-color: ${props => props.dataBackground ?? '#ffffff'};
  border: 1px solid ${props => props.dataOutline ?? 'transparent'};

  &:disabled {
    opacity: 0.5;
  }
`;
